import { Account } from '../data/account';

export class Student {
  ID: number;
  Name: string;
  PassCode: string;
  ExternalID?: string;
  ExpirationDate?: Date;
  TrialDays?: number;
  Parents: Account[];
  OrganizationID: number;
  CurrentCourse: string;
  ReassignmentCourse: string;
  ReassignmentUnit: number;
  GradeLevel: string;

  static gradeLevelOptions: string[] = [
    'PK',
    'K',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12'
  ]

  static getGradeLevelString(gradeLevel: string) {
    return gradeLevel === 'PK' ? 'Pre-K' : gradeLevel === 'K' ? 'Kindergarten' : gradeLevel;
  }
}
